import { FileText } from "lucide-react";
import { toast } from "sonner";
import { openDocument, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";

export default function DocList({ docs, testPrefix = "doc" }) {
  if (!docs?.length) return <p className="text-sm text-slate-500">{t("No documents uploaded.")}</p>;
  const open = async (id) => {
    try { await openDocument(id); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <ul className="space-y-2">
      {docs.map((d) => (
        <li key={d.id}>
          <button onClick={() => open(d.id)} data-testid={`${testPrefix}-${d.id}`} className="w-full flex items-center gap-3 p-3 rounded-md border border-slate-200 hover:border-amber-500 hover:bg-amber-50/40 text-left transition-colors">
            <FileText className="w-4 h-4 text-amber-600 shrink-0" />
            <span className="min-w-0">
              <span className="block text-sm font-semibold truncate">{d.doc_type}</span>
              <span className="block text-xs text-slate-500 truncate">{d.filename}</span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
